import { render, staticRenderFns } from "./spmscoringEmail.vue?vue&type=template&id=40b63d44&scoped=true&"
import script from "./spmscoringEmail.vue?vue&type=script&lang=js&"
export * from "./spmscoringEmail.vue?vue&type=script&lang=js&"
import style0 from "./spmscoringEmail.vue?vue&type=style&index=0&id=40b63d44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b63d44",
  null
  
)

export default component.exports